<template>
	<!-- 填空 -->
	<div class="p_m_t_30">
		<div class="p_flex">
			<div class="xuan type_size_22">题目内容</div>
			<div class="choice_input p_m_l_30">
				<question-wangeditor
					ref="childs"
					v-model="topicContent.title"
					:name="topic"
					:option="1"
					:height="120"
					:width="840"
					:val="topicVal"
				></question-wangeditor>
			</div>
		</div>
		<div class="p_flex p_m_t_30">
			<div class="xuan  p_flex p_f_e type_size_22">学生答题</div>
			<div class="choice_input p_m_l_30">
				<el-radio-group v-model="radio" @change="change">
					<el-radio :label="1">文字答题</el-radio>
					<el-radio :label="2">上传图片答题</el-radio>
					<el-radio :label="3">全部</el-radio>
				</el-radio-group>
			</div>
		</div>
		<div class="p_flex ">
			<div class="xuan p_m_t_30 p_flex p_f_e type_size_22">答案</div>
			<div id="">
				<div class="choice_input p_m_l_30 p_m_t_30" v-for="(item, index) in topicContent.affiliation" :key="index">
					<el-input type="text" placeholder="请填写答案"  v-model="item.text">
						<div slot="prepend">{{ index + 1 }}.</div>
						<div slot="append" @click="deleteEle(index)"><el-button type="primary" icon="el-icon-remove-outline"></el-button></div>
					</el-input>
				</div>
			</div>

		</div>
		<div class="p_flex p_m_t_30">
			<div class="xuan type_size_22"></div>
			<div class="add_box p_m_l_30 small_hand" @click="addEle">添加</div>
		</div>
	</div>
</template>

<script>
import QuestionWangeditor from './questionWangeditor.vue';
export default {
	components: {
		QuestionWangeditor
	},
	data() {
		return {
			// 题目内容
			topic: 'topic',
			topicVal: '',
			coter: 1,
			// 选项
			topList: [{text: '' }],
			radio: 3
		};
	},
	props: {
		topicContent: {
			type: Object
			// default() {
			// 	return this.$refs['childs'].getHtml();
			// }
		},
		clear:null
	},
	watch:{
		clear(n,o){
			if( n ){
				this.$refs.childs.sing()
				this.topicContent.affiliation = [
					{
						text:''
					}
				]
			}
		}
	},
	created() {
		this.topicContent.affiliation = []
			this.topicContent.answer_mode = this.radio
		if (this.topicContent.affiliation.length == 0) {
			this.topicContent.affiliation = [
				{
					text:''
				}
			]
		}
	},
	mounted() {},
	methods: {
		goContinue() {
			const that = this;
			that.$refs.childs.sing();
		},
		change(e){
			this.topicContent.answer_mode = e
		},
		addEle() {
			this.topicContent.affiliation.push({
				text: ''
			});
		},
		// 删除
		deleteEle(i) {
			this.topicContent.affiliation.splice(i, 1);
		},
	}
};
</script>

<style lang="scss" scoped>
.choice_input {
	width: 840px;
}

.xuan {
	width: 88px;
}

.add_box {
	width: 94px;
	height: 33px;
	background: #fbb13c;
	border-radius: 6px;
	text-align: center;
	line-height: 33px;
	font-size: 14px;
	color: #ffffff;
}
>>> .el-input__inner {
	border: none;
	background-color: #f5f5f5;
	font-size: 18px;
	color: #333;
	padding: 0;
}

>>> input::-webkit-input-placeholder {
	font-size: 18px;
}

>>> .el-input-group__prepend {
	border: none;
}
>>> .el-input-group__append,
>>> .el-input-group__prepend {
	font-size: 18px;
}
>>> .el-input-group__append,
>>> .el-input-group__prepend {
	border: none;
}
>>> .el-radio__input.is-checked .el-radio__inner {
	border-color: #00af63;
	background: #00af63;
}
>>> .el-radio__input.is-checked + .el-radio__label {
	color: #00af63;
}
>>> .el-radio__inner {
	width: 20px;
	height: 20px;
}
>>> .el-radio__label {
	font-size: 18px;
}
>>> .el-radio__inner:hover {
	border-color: #999999;
}
>>> .el-radio__inner::after {
	width: 8px;
	height: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/singleFilling.vue